import { NaniumObject, Type } from 'nanium/objects';
import { NaniumBuffer } from 'nanium/interfaces/naniumBuffer';
import { NaniumStream } from 'nanium/interfaces/naniumStream';

export type BucketNames = 'info' | 'application' | 'export' | 'invoice';

export class CoreFile extends NaniumObject<CoreFile> {
	@Type(String) id?: string;
	@Type(String) fileName: string;
	@Type(Number) size: number;
	@Type(String) mimeType: string;
	@Type(Object) metaData?: any;
	@Type(String) accountId?: string;
	@Type(Date) creationDate: Date;

	@Type(NaniumBuffer) buffer?: NaniumBuffer;
	@Type(NaniumStream, NaniumBuffer) stream?: NaniumStream<NaniumBuffer>;
}
